<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#fff"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <rect
      x="4"
      y="11"
      width="16"
      height="10"
      rx="2.5"
      fill="#fff"
      fill-opacity=".2"
    />
    <path d="M8 11V8a4 4 0 0 1 8 0v3" />
  </svg>
</template>

<script>
export default {
  name: 'IconLockBadge',
  props: {
    size: { type: [String, Number], default: 11 },
    strokeWidth: { type: [String, Number], default: 2.6 },
  },
};
</script>
